import React from "react";
import moment from "moment-jalaali";
import "./Prices.scss";
import PriceTable from "../PriceTable";

const Prices = ({ currencies, coins, nimaiis }) => {
  // Find the item with the latest updatedAt
  const latestUpdate = coins?.reduce((latest, item) => {
    const latestTime = new Date(latest?.updatedAt || 0).getTime();
    const currentTime = new Date(item?.updatedAt || 0).getTime();
    return currentTime > latestTime ? item : latest;
  }, null);

  // Convert to Jalali date and time
  const jalaliDate = latestUpdate?.updatedAt
    ? moment(latestUpdate.updatedAt).format("jYYYY/jMM/jDD")
    : "تاریخ نامشخص";
  const jalaliTime = latestUpdate?.updatedAt
    ? moment(latestUpdate.updatedAt).format("HH:mm:ss")
    : "زمان نامشخص";

  return (
    <div className="prices-container wide-page-margin" id="prices">
      <div className="flex flex-col justify-center items-center mb-[2.75rem]">
        <div className="title">نرخ خرید و فروش ارز و سکه</div>
        <div className="update-date">آخرین بروزرسانی: {jalaliDate}</div>
        <div className="update-time">ساعت: {jalaliTime}</div>
      </div>
      <div className="price-tables flex gap-[1.58rem]">
        <PriceTable data={currencies} type={"currency"} />
        <div className="w-[100%] flex flex-col gap-[1.63rem]">
          <PriceTable data={coins} type={"coin"} />
          <PriceTable data={nimaiis} type={"tgju"} />
          {/* <PriceTable data={nimaiis} type={"nimaii"} /> */}
        </div>
      </div>
    </div>
  );
};

export default Prices;
